import { WintSuperkollAPIModelFinancialReport } from "wint-api-client/dist/types";
import { AuditSheetNavigationItem } from "models/propTypes/accountingPropTypes";

export const getAccountTitle = (row: WintSuperkollAPIModelFinancialReport.FinancialReportRow) =>
  `${row.detailedDescription} - ${row.description}`;

export const buildAuditSheetNavigationList = (
  rows: WintSuperkollAPIModelFinancialReport.FinancialReportRow[],
  columnIndex: number
): AuditSheetNavigationItem[] =>
  rows.flatMap((row) => {
    const column = row.columns?.[columnIndex];
    // A row that opens a sheet must be in the list, or navigating from it would have no starting point.
    const own: AuditSheetNavigationItem[] =
      row.isAccount || column?.auditSheetId
        ? [{ title: getAccountTitle(row), auditSheetId: column?.auditSheetId, balance: column?.uB }]
        : [];

    return [...own, ...buildAuditSheetNavigationList(row.children ?? [], columnIndex)];
  });

export const findAuditSheetNavigationIndex = (items: AuditSheetNavigationItem[], auditSheetId: number) => {
  const index = items.findIndex((item) => item.auditSheetId === auditSheetId);
  return index >= 0 ? index : undefined;
};
